import { createStore } from 'effector';
import world from '../../data/world.json';

export const gradient_init = {
  buckets: [0, 5, 10, 15, 20, 25, 50],
  colors: [
    '#b6e0f2',
    '#b5d1f1',
    '#ffe5c7',
    '#1f5da4',
    '#002b5b',
    '#001a38',
    '#4d0006',
  ],
};

export const $worldPolygons = createStore(world.features);
$worldPolygons.watch((state) => console.log('$worldPolygons', state));

export const $currentCategory = createStore('100111');

export const $hsCodes = createStore([]);

export const $activeLayer = createStore('tariff');

export const $ABGradient = createStore(gradient_init);
$ABGradient.watch((state) => console.log('$ABGradient', state));

export const $ABModal = createStore(false)

export const $filterModal = createStore(false)
